import { createComponent } from '@carvana/merch-components';
import React, { forwardRef } from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const GreenCheck = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg viewBox="0 0 19 19" ref={ref} {...props}>
    <path d="M9.5,0A9.5,9.5,0,1,0,19,9.5,9.51,9.51,0,0,0,9.5,0Zm4.66,6.33L8.32,14,5.2,10.73a.94.94,0,0,1,0-1.31.93.93,0,0,1,1.31,0l1.63,1.69,4.53-5.93a.92.92,0,0,1,1.47,1.12Z" />
  </svg>
));

const GreenCheckIcon = createComponent(GreenCheck, {
  className: `h-[19px] w-[19px] fill-green-2`
});

export default GreenCheckIcon;
